/**
 * Si creamos un nuevo evento tenemos que reemitirlo en el LfGridPersistedComponent
 */

export const gridEmits = ['rowClick', 'contextMenuClicked', 'toolbarClicked', 'rowsSelected', 'contextMenuBeforeOpen', 'dataStateChange']

export type GridEmitsType = typeof gridEmits[number]
